import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';
import { LeadaComponentsModule } from 'shared/components';

import { MenuPage } from './components/menu-page/menu-page';
import { KnowHowPage } from './components/knowhow-page/knowhow-page';
import { TodayPage } from './components/today-page/today-page';
import { CoreFactsPage } from './components/corefacts-page/corefacts-page';
import { PersonalPage } from './components/personal-page/personal-page';
import { ProfilePage } from './components/profile-page/profile-page';
import { GenericPage } from './components/generic-page/generic-page';
import { ThesesPage } from './components/theses-page/theses-page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    RouterModule.forChild([
      { path: '', component: MenuPage },
      { path: 'knowhow', component: KnowHowPage },
      { path: 'today', component: TodayPage },
      { path: 'personal', component: PersonalPage },
      { path: 'corefacts', component: CoreFactsPage },
      { path: 'corefacts/generic', component: GenericPage },
      { path: 'profile', component: ProfilePage },
      { path: 'theses', component: ThesesPage },
    ]),
    LeadaComponentsModule,
  ],
  providers: [
    // UserRepository,
    // UserService,
  ],
  declarations: [
    MenuPage,
    KnowHowPage,
    TodayPage,
    PersonalPage,
    CoreFactsPage,
    ProfilePage,
    GenericPage,
    ThesesPage,
  ],
  // entryComponents: [
  //   MenuPage,
  //   KnowHowPage,
  //   TodayPage,
  //   PersonalPage,
  //   CoreFactsPage,
  //   ProfilePage,
  //   ThesesPage,
  // ],
})
export class MenuModule { }
